import React, { useState } from 'react';
import circleCheck from '../../../../../assets/image/circle-check.svg';
import '../../get_started.scss';
import { useNavigate, useParams } from 'react-router-dom';
import { skipModule } from '../../../../../services/dashboard';
import { toast } from 'react-toastify';
import { PageSmallLoader } from '../../../../../component/PageLoader';

export default function ExpandedTab({
	tasksList,
	setOpenIndex,
	openIndex,
	index,
	handleFetchGettingStartedData,
}) {
	const navigate = useNavigate();
	const params = useParams();
	const [isSkipLoader, setSkipLoader] = useState({
		isloading: false,
		key: null,
	});

	const handleActionClick = (task) => {
		if (task.action) {
			navigate(`/user/${params.suburl}/${task.action}`);
		} else if (task.onClick) {
			task.onClick();
		}
	};

	const handleSkipButton = async (key) => {
		try {
			setSkipLoader((prev) => ({
				...prev,
				isloading: true,
				key: key,
			}));
			var body = {
				sub_module_key: key,
				is_completed: true,
				is_skip: true,
			};
			await skipModule(body);
			toast.success('Module successfully skipped');
			handleFetchGettingStartedData();
		} catch (e) {
			toast.error(e);
		} finally {
			setSkipLoader((prev) => ({
				...prev,
				isloading: false,
				key: null,
			}));
		}
	};

	return (
		<div className="setup-content">
			{tasksList.map((task, i) => {
				const isDone = Boolean(task.done);

				return (
					<div
						key={i}
						className={`task-row ${isDone ? 'done' : ''}`}
					>
						{/* Task Info */}
						<div className="task-info">
							<div
								className="task-title"
								style={{ color: isDone ? '#D9D9D9' : '#555B67' }}
							>
								{task.name}
							</div>
							{task.desc && (
								<div
									className="task-description"
									style={{ color: isDone ? '#D9D9D9' : '#555B67' }}
								>
									{task.desc}
								</div>
							)}
						</div>

						{/* Actions */}
						<div className="task-actions">
							{/* If completed */}
							{isDone && (
								<>
									<div className="checkIcon">
										<img
											src={circleCheck}
											style={{ cursor: 'pointer' }}
											onClick={() => setOpenIndex(openIndex === index ? null : index)}
											alt="Completed"
										/>
									</div>
									<div
										className="btn-skip"
										style={{ color: '#D9D9D9' }}
									>
										Skip
									</div>
								</>
							)}

							{/* If not completed */}
							{!isDone && (
								<>
									{task.action && (
										<button
											className="btn-primary"
											onClick={() => handleActionClick(task)}
										>
											{task.button_title}
										</button>
									)}
									<div
										className="btn-skip"
										style={{ color: '#555B67' }}
										onClick={() => handleSkipButton(task.key)}
									>
										{isSkipLoader.isloading && isSkipLoader.key === task.key ? (
											<PageSmallLoader />
										) : (
											'Skip'
										)}
									</div>
								</>
							)}
						</div>
					</div>
				);
			})}
		</div>
	);
}
